// src/pages/Admin/Dashboard/Events/components/EventsHero.jsx

import React from "react";
import {
  FaCalendarAlt,
  FaCheckCircle,
  FaPlus,
  FaSyncAlt,
  FaUserPlus,
} from "react-icons/fa";

import { formatNumber } from "../utils/eventsUtils";

export default function EventsHero({
  loading,
  total,
  activeCount,
  onCreate,
  onRefresh,
}) {
  return (
    <section className="relative overflow-hidden rounded-[2rem] border border-slate-200 bg-slate-950 p-6 text-white shadow-xl shadow-slate-300/40 dark:border-slate-800 dark:shadow-none lg:p-8">
      <div className="absolute -right-24 -top-24 h-72 w-72 rounded-full bg-blue-500/30 blur-3xl" />
      <div className="absolute -bottom-28 left-1/3 h-72 w-72 rounded-full bg-orange-500/20 blur-3xl" />

      <div className="relative flex flex-col gap-6 xl:flex-row xl:items-end xl:justify-between">
        <div className="max-w-3xl">
          <p className="text-sm font-bold uppercase tracking-[0.24em] text-blue-200">
            Agenda du club
          </p>

          <h1 className="mt-4 text-3xl font-bold tracking-tight sm:text-4xl">
            Gestion des événements
          </h1>

          <p className="mt-4 max-w-2xl text-sm leading-7 text-slate-300 sm:text-base">
            Créez les stages, animations, compétitions, passages de grade ou
            événements publics du club. Les visiteurs pourront ensuite consulter
            les événements actifs et s’inscrire sans compte.
          </p>
        </div>

        <div className="grid gap-3 sm:grid-cols-2 xl:min-w-[390px]">
          <div className="rounded-3xl border border-white/10 bg-white/10 p-4 backdrop-blur">
            <p className="text-xs uppercase tracking-[0.18em] text-slate-300">
              Événements
            </p>
            <p className="mt-2 text-3xl font-bold">
              {loading ? "..." : formatNumber(total)}
            </p>
          </div>

          <div className="rounded-3xl border border-white/10 bg-white/10 p-4 backdrop-blur">
            <p className="text-xs uppercase tracking-[0.18em] text-slate-300">
              Actifs
            </p>
            <p className="mt-2 text-3xl font-bold">
              {loading ? "..." : formatNumber(activeCount)}
            </p>
          </div>
        </div>
      </div>

      <div className="relative mt-6 flex flex-wrap items-center gap-3">
        <button
          type="button"
          onClick={onCreate}
          className="inline-flex items-center gap-2 rounded-2xl bg-white px-4 py-2.5 text-sm font-bold text-slate-950 shadow-lg shadow-black/20 transition hover:-translate-y-0.5 hover:bg-blue-50"
        >
          <FaPlus />
          Créer un événement
        </button>

        <button
          type="button"
          onClick={onRefresh}
          className="inline-flex items-center gap-2 rounded-2xl border border-white/10 bg-white/10 px-4 py-2.5 text-sm font-bold text-white transition hover:-translate-y-0.5 hover:bg-white/15"
        >
          <FaSyncAlt />
          Actualiser
        </button>

        <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/10 px-4 py-2 text-sm text-slate-300">
          <FaCalendarAlt />
          Affichage public
        </span>

        <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/10 px-4 py-2 text-sm text-slate-300">
          <FaUserPlus />
          Inscriptions visiteurs
        </span>

        <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/10 px-4 py-2 text-sm text-slate-300">
          <FaCheckCircle />
          Activation rapide
        </span>
      </div>
    </section>
  );
}